
import React from 'react';
import { Trash2 } from 'lucide-react';
import OptimizedImage from '../OptimizedImage';
import { CartItem } from '../../types';

interface CartItemRowProps {
    item: CartItem;
    onRemove: (listingId: string) => void;
    // Future: quantity update handler
}

const CartItemRow: React.FC<CartItemRowProps> = ({ item, onRemove }) => {
    return (
        <div className="flex gap-4 group bg-white dark:bg-gray-950 transition-colors">
            {/* Image */}
            <div className="w-20 h-24 bg-gray-50 dark:bg-gray-900 rounded-2xl overflow-hidden flex-shrink-0 border border-gray-100 dark:border-gray-800">
                <OptimizedImage
                    src={item.image}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    alt={item.title}
                />
            </div>

            {/* Details */}
            <div className="flex-1 flex flex-col justify-between py-2">
                <div>
                    <h4 className="font-black text-xs text-gray-950 dark:text-white line-clamp-2 leading-tight uppercase tracking-tight">{item.title}</h4>
                    <div className="mt-1.5 flex items-baseline gap-2">
                        <p className="text-gray-900 dark:text-white font-black text-lg italic tracking-tighter">₺{item.priceAtAdd?.toLocaleString('tr-TR')}</p>
                    </div>
                </div>

                <div className="flex justify-between items-center">
                    <span className="text-[10px] text-gray-400 dark:text-gray-500 font-black uppercase tracking-[0.2em]">Adet: {item.quantity}</span>

                    <button
                        onClick={() => onRemove(item.listingId)}
                        className="text-gray-400 dark:text-gray-500 hover:text-rose-500 dark:hover:text-rose-400 hover:bg-rose-500/5 dark:hover:bg-rose-500/10 w-8 h-8 flex items-center justify-center rounded-xl transition-all active:scale-95"
                        aria-label={`${item.title} ürününü sepetten çıkar`}
                    >
                        <Trash2 size={16} strokeWidth={3} aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CartItemRow;
